import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { Col, Row } from 'antd'
import Control from 'components/Control/Control'
import AntdInput from 'components/Form/Input'
import InputNumber from 'components/Form/InputNumber'

export const CommonFlex = styled(Flex)`
  margin-top: 25px;
  width: ${props => (props?.width ? props?.width : '100%')};
`
export const RightDiv = styled.div``
export const RowPadding = styled(Row)`
  padding: 15px;
`
export const ButtonCenterPadding = styled(Col)`
  padding-top: 50px;
`
export const ImageFlex = styled(Flex)`
  gap: 10px;
`
export const ImageColPadding = styled(Col)`
  padding: 12px 10px 0;
`
export const ImageUploadWrapper = styled(Flex)`
  background: ${COLORS.BLUE_T_97};
  border: 1px dashed #98a4eb;
  border-radius: 50%;
  height: 110px;
  width: 110px;
  ${ImageUploadWrapper} > ${Control} > div {
    font-weight: ${FONT.FW_500};
    font-size: 8px;
    line-height: 8px;
    color: ${COLORS.GREY_T_80};
  }
`
export const ImageTag = styled.img`
  border-radius: 50%;
  height: 110px;
  width: 110px;
`
export const ComanyDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`

export const AlertFlex = styled(Flex)`
  background: ${COLORS.RED_T_90};
  border-radius: 10px;
  padding: 10px;
  margin: 25px 0;
  gap: 12px;
  width: fit-content;
`
export const ErrorMsgDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 24px;
  color: ${COLORS.GREY_T_20};
`
export const SubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const RightSection = styled.div`
  width: 60%;
`
export const ImageSpan = styled.span`
  margin-left: 7px;
`
export const TextAreaDiv = styled.div`
  width: 50%;
`
export const SubDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const Divider = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  margin: 20px 0px;
  height: 56px;
`
export const StyledSelectDiv = styled(Flex)`
  height: 48px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right: 0;
  }
`
export const StyledInput = styled(AntdInput)`
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
`
export const StyledInputDiv = styled(Flex)`
  margin-bottom: 20px !important;
  align-items: baseline;
  width: 100%;
  border-radius: 8px;
  .ant-inputselect:not(.ant-select-customize-input) .ant-select-selector {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
`
export const AddressFlex = styled(Flex)`
  gap: 25px;
`
export const MainWrapper = styled.div`
  padding-right: 15%;
  ${props => props?.marginBottom && `margin-bottom: ${props?.marginBottom}`}
`
export const TierInputNumber = styled(InputNumber)`
  padding-top: 3px !important;
  .ant-input-number-handler-wrap {
    display: none !important;
  }
  .ant-input-number-suffix {
    display: none;
  }
`
